import { buildMakeUseAxios } from "@root/api/api.tools";
import { useCallback } from "react";

const axios = buildMakeUseAxios(`${import.meta.env.VITE_CANDIDATE_SERVICE_URL}/v2`);

export interface IGetAutocompleteCandidate {
  _id: string;
  firstName: string;
  lastName: string;
  profileId: number;
}

export const useGetAutocompleteCandidate = () => {
  const [state, execute, cancel] = axios<IGetAutocompleteCandidate[], void, unknown>(
    {
      url: "/candidates/autocomplete",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (params: { name: string }) => {
      return execute({
        url: "/candidates/autocomplete",
        params,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
